<div class="no-results-div">
  <mat-icon svgIcon="funnel-x" class="no-results-icon"> </mat-icon>
  <h6 class="no-results-title">No matching results</h6>
  <div class="no-results-message">
    <span>Your current filter selection returned no results. Try</span>
    <span>adjusting the filters to see available data.</span>
  </div>
</div>
